/** SERVICE SNAPSHOT — tenant-safe operational summary read through the Business Service Layer (reports.summary). */
import { useEffect, useState } from "react";
import { svc } from "@/lib/services";

export default function ServiceSnapshot({ channel = "PORTAL", tenantId }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { svc.read("reports.summary", tenantId ? { master_company_id: tenantId, days: 30 } : { days: 30 }, channel).then((r) => setD(r.data)).catch((e) => setErr(e.response?.data?.detail || "Unavailable")); }, [channel, tenantId]);
  if (err) return null;
  if (!d) return <div className="os-skeleton h-16 rounded-xl" />;
  const items = [["Devices", d.devices.total], ["Warranty ≤ 90d", d.devices.warranty_expiring_90d], ["Open orders", d.orders.open], ["In transit", d.shipments.in_transit], ["Open tickets", d.support.open], ["Open recoveries", d.recoveries.open], ["Overdue pickups", d.recoveries.overdue]];
  return (
    <div className="os-card p-3 flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="service-snapshot">
      <div className="text-[10px] uppercase tracking-[0.12em] text-[color:var(--st-text-muted)] font-medium">Last 30 days · via service layer</div>
      {items.map(([l, v]) => <div key={l} className="text-[12px]" data-testid={`snap-${l.replace(/[^a-z]/gi, "-").toLowerCase()}`}><span className="text-[color:var(--st-text-muted)]">{l}</span> <b className="tabular-nums ml-1">{v}</b></div>)}
    </div>
  );
}
